import React from 'react';
import {
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup
} from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';

import { useAppDispatch, useAppSelector } from "store";
import {
    selectFootfallByAreaMeasure,
    setFootfallByAreaMeasure
} from "modules/customer/tools/location/footfallNew/footfallSlice";

import { FootfallMeasureType } from "modules/customer/tools/location/footfallNew/footfallMeasureType";

const StyledRadio = withStyles(theme => ({
    root: {
        '&$checked': {
            // @ts-ignore
            color: theme.palette.tertiary.main
        },
    },
    checked: {},
}))(Radio);

export default function RadioButtonsGroup() {
    const dispatch = useAppDispatch();
    const measure = useAppSelector(selectFootfallByAreaMeasure);
    const [value, setValue] = React.useState(measure);

    // @ts-ignore
    const handleChange = (event) => {
        dispatch(setFootfallByAreaMeasure(event.target.value));
        setValue(event.target.value);
    };

    return (
        <FormControl component="fieldset">
            <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleChange}>
                <FormControlLabel value={FootfallMeasureType.NumberOfVisits} control={<StyledRadio />} label="Visits" />
                <FormControlLabel value={FootfallMeasureType.DwellTime} control={<StyledRadio />} label="Dwell time" />
            </RadioGroup>
        </FormControl>
    );
}
